<template>
  <div class="welcome-message-wrapper">
    <Notify
      v-if="welcomeMessageText?.length"
      v-html="welcomeMessageText"
      :style="`${notification.enabled ? 'margin-top: 15px; ' : ''}`"
    ></Notify>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Notify from '../../../components/ui/Notify/index.vue'

export default {
  props: {},
  components: {
    Notify,
  },
  computed: {
    ...mapGetters('attendeeStore', ['welcomeMessageText', 'notification']),
  }
}
</script>

<style lang="scss" scoped>
@media (max-width: 900px) {
  .welcome-message-wrapper {
    padding: 0 var(--attendee-gap-md);
  }
}
</style>